/**
 * PrintFlow RFQ capture — hooks the Globo contact form so every submission
 * also lands in PrintFlow as an inquiry (POST /api/lead/rfq), with full
 * field mapping. Also injects an "instant quote" banner above the form.
 *
 * Loaded site-wide via snippets/printflow-advisor.liquid; exits instantly on
 * pages without the Globo form. Never interferes with the form's own submit.
 */
(function () {
  'use strict';
  var API = (window.PF_ADVISOR_CONFIG && window.PF_ADVISOR_CONFIG.apiUrl) ||
    'https://technoprintflow-backend-production.up.railway.app';

  function text(el) {
    return (el.textContent || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim();
  }

  function collect(form) {
    var fields = [];
    form.querySelectorAll('.globo-form-control').forEach(function (ctrl) {
      var lab = ctrl.querySelector('label');
      var q = lab ? text(lab) : '';
      var vals = [];
      ctrl.querySelectorAll('input,select,textarea').forEach(function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') {
          if (el.checked) {
            var l = el.closest('label');
            vals.push(l ? text(l) : el.value);
          }
        } else if (el.type === 'file') {
          for (var i = 0; i < (el.files || []).length; i++) vals.push(el.files[i].name);
        } else if (el.tagName === 'SELECT') {
          var o = el.options[el.selectedIndex];
          if (o && !/please select/i.test(o.text)) vals.push(o.text.trim());
        } else if (el.value && el.type !== 'hidden') {
          vals.push(el.value.trim());
        }
      });
      if (q || vals.length) fields.push({ q: q, v: vals.join(', ') });
    });
    return fields;
  }

  function pick(fields, re) {
    var f = fields.find(function (x) { return re.test(x.q); });
    return f && f.v ? f.v : null;
  }

  function send(fields) {
    var first = pick(fields, /^first name/i);
    var last  = pick(fields, /^last name/i);
    var email = pick(fields, /^e-?mail/i);
    if (!email || !(first || last)) return;            // not enough to be a lead

    var KEY = 'pf_rfq_' + email.toLowerCase();
    try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, '1'); } catch (e) {}

    var known = [/^first name/i, /^last name/i, /^e-?mail/i, /^phone/i, /hear about/i,
      /quote request type/i, /inquiry type/i, /company/i, /project detail/i, /delivery/i,
      /shipping address/i, /^quantity/i, /timeframe/i, /environment/i, /physical part/i,
      /colou?r/i, /post-?processing/i, /design file/i, /reference/i];
    var extras = fields.filter(function (x) {
      return x.v && !known.some(function (re) { return re.test(x.q); });
    }).map(function (x) { return (x.q || 'Field') + ': ' + x.v; });

    var details = [pick(fields, /project detail/i), extras.join('\n')].filter(Boolean).join('\n');

    fetch(API + '/api/lead/rfq', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        first_name: first, last_name: last, email: email,
        phone:               pick(fields, /^phone/i),
        heard_about:         pick(fields, /hear about/i),
        quote_type:          pick(fields, /quote request type/i),
        inquiry_type:        pick(fields, /inquiry type/i),
        company:             pick(fields, /company/i),
        project_details:     details || null,
        delivery_preference: pick(fields, /delivery/i),
        shipping_address:    pick(fields, /shipping address/i),
        quantity:            pick(fields, /^quantity/i),
        timeframe:           pick(fields, /timeframe/i),
        environment:         pick(fields, /environment/i),
        physical_part:       pick(fields, /physical part/i),
        colour:              pick(fields, /colou?r/i),
        post_processing:     pick(fields, /post-?processing/i),
        files:               (pick(fields, /design file/i) || '').split(', ').filter(Boolean),
        reference_files:     (pick(fields, /reference/i) || '').split(', ').filter(Boolean),
        page_url:            location.href,
        imported_from:       'globo_form_capture',
        request_type:        'rfq'
      })
    }).catch(function () {});
  }

  function injectBanner(form) {
    if (document.getElementById('pf-iq-banner')) return;
    var a = document.createElement('a');
    a.id = 'pf-iq-banner';
    a.href = '/pages/instant-quote';
    a.innerHTML = '⚡ <strong>Have a 3D file ready?</strong> Skip the form — get an instant quote in seconds →';
    a.style.cssText = 'display:block;margin:0 0 18px;padding:14px 18px;border-radius:10px;background:#2563eb;color:#fff;text-decoration:none;font-size:15px;line-height:1.5;text-align:center;';
    form.parentElement.insertBefore(a, form);
  }

  function init() {
    var form = document.querySelector('form.g-container');
    if (!form || form.__pfHooked) return;
    form.__pfHooked = true;
    injectBanner(form);
    // capture phase so we run regardless of Globo's own handler
    form.addEventListener('submit', function () {
      try { send(collect(form)); } catch (e) {}
    }, true);
  }

  // Globo injects its form late — poll briefly until it appears
  var tries = 0;
  var timer = setInterval(function () {
    init();
    if (document.querySelector('form.g-container') || ++tries > 24) clearInterval(timer);
  }, 500);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
